import Lenis from "lenis";

let lenis = null;

export function initLenis() {
  lenis = new Lenis({ duration: 1.15, smoothWheel: true });
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
  return lenis;
}

export function getLenis() {
  return lenis;
}

export function scrollToTarget(target) {
  if (lenis) {
    lenis.scrollTo(target, { offset: target === 0 ? 0 : -80 });
  } else if (target === 0) {
    window.scrollTo(0, 0);
  } else {
    target?.scrollIntoView();
  }
}
